import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getProjects } from '../data/projects';

/* ============================================================
   STYLES INTÉGRÉS
============================================================ */
const STYLES = `
  .adm { min-height: 100vh; background: #0a0a0a; font-family: 'Barlow', sans-serif; color: #f0f0f0; }

  /* ---- LOGIN ---- */
  .adm-login {
    min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px;
    background: #0a0a0a;
  }
  .adm-login-box {
    width: 100%; max-width: 400px;
    background: #111; border: 1px solid rgba(255,255,255,0.07);
    padding: 48px 40px;
  }
  .adm-login-logo {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900; font-size: 1.3rem;
    letter-spacing: 0.05em; margin-bottom: 32px; display: block;
  }
  .adm-login-logo span { color: #7b10e0; }
  .adm-login-title {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
    font-size: 2.2rem; text-transform: uppercase; line-height: 0.95; margin-bottom: 6px;
  }
  .adm-login-sub { font-size: 0.82rem; color: #555; font-weight: 300; margin-bottom: 36px; }
  .adm-login-label {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.58rem; font-weight: 700;
    letter-spacing: 0.22em; text-transform: uppercase; color: #555; margin-bottom: 8px; display: block;
  }
  .adm-login-input {
    width: 100%; background: #0a0a0a; border: 1px solid rgba(255,255,255,0.08);
    color: #f0f0f0; font-family: 'Space Mono', monospace; font-size: 0.88rem;
    padding: 14px 16px; outline: none; transition: border-color 0.2s; margin-bottom: 6px;
  }
  .adm-login-input:focus { border-color: #7b10e0; }
  .adm-login-input.err { border-color: #ff4444; }
  .adm-login-btn {
    width: 100%; background: #7b10e0; color: #fff; border: none; cursor: pointer;
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.88rem; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase; padding: 14px; margin-top: 12px;
    transition: background 0.2s;
  }
  .adm-login-btn:hover { background: #6209b8; }
  .adm-login-err {
    font-size: 0.75rem; color: #ff6666; margin-top: 10px; font-family: 'Space Mono', monospace;
    display: flex; align-items: center; gap: 6px;
  }
  .adm-login-hint {
    font-size: 0.72rem; color: #333; margin-top: 24px; line-height: 1.7;
    border-top: 1px solid rgba(255,255,255,0.05); padding-top: 20px;
  }
  .adm-login-hint code { font-family: 'Space Mono', monospace; color: #7b10e0; }

  /* ---- NAV ADMIN ---- */
  .adm-nav {
    position: sticky; top: 0; z-index: 100;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 48px; height: 60px;
    background: rgba(8,8,8,0.97); backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(255,255,255,0.07);
  }
  .adm-nav-left { display: flex; align-items: center; gap: 20px; }
  .adm-nav-logo {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
    font-size: 1.2rem; letter-spacing: 0.05em; text-decoration: none; color: #f0f0f0;
  }
  .adm-nav-logo span { color: #7b10e0; }
  .adm-nav-badge {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.58rem; font-weight: 700;
    letter-spacing: 0.18em; text-transform: uppercase;
    background: rgba(123,16,224,0.15); border: 1px solid rgba(123,16,224,0.3);
    color: #7b10e0; padding: 3px 10px;
  }
  .adm-nav-right { display: flex; align-items: center; gap: 16px; }
  .adm-nav-site {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.72rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase; text-decoration: none;
    color: #555; transition: color 0.2s;
  }
  .adm-nav-site:hover { color: #f0f0f0; }
  .adm-nav-logout {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.72rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase; cursor: pointer;
    background: transparent; border: 1px solid rgba(255,255,255,0.1);
    color: #555; padding: 7px 16px; transition: all 0.2s;
  }
  .adm-nav-logout:hover { border-color: #ff4444; color: #ff6666; }

  /* ---- TABS ---- */
  .adm-tabs {
    display: flex; gap: 0;
    border-bottom: 1px solid rgba(255,255,255,0.07);
    background: #0e0e0e; padding: 0 48px; overflow-x: auto;
  }
  .adm-tab {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.75rem; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase; cursor: pointer;
    background: none; border: none; color: #555; padding: 16px 24px;
    border-bottom: 2px solid transparent; transition: all 0.2s; white-space: nowrap;
  }
  .adm-tab:hover { color: #f0f0f0; }
  .adm-tab.active { color: #f0f0f0; border-bottom-color: #7b10e0; }

  /* ---- CONTENT ---- */
  .adm-content { padding: 40px 48px; }

  /* ---- STATS ---- */
  .adm-stats {
    display: grid; grid-template-columns: repeat(4, 1fr);
    gap: 2px; background: rgba(255,255,255,0.05);
    margin-bottom: 40px;
  }
  .adm-stat {
    background: #111; padding: 28px 24px; position: relative; overflow: hidden;
  }
  .adm-stat::before {
    content: ''; position: absolute; top: 0; left: 0; right: 0; height: 2px;
  }
  .adm-stat:nth-child(1)::before { background: #7b10e0; }
  .adm-stat:nth-child(2)::before { background: #00E5FF; }
  .adm-stat:nth-child(3)::before { background: #FFD600; }
  .adm-stat:nth-child(4)::before { background: #7b10e0; }
  .adm-stat-num {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
    font-size: 2.8rem; line-height: 1; margin-bottom: 6px;
  }
  .adm-stat-label {
    font-size: 0.62rem; font-weight: 700; letter-spacing: 0.18em;
    text-transform: uppercase; color: #555;
  }

  /* ---- CTA UPLOAD ---- */
  .adm-cta-upload {
    background: #111; border: 1px solid rgba(255,255,255,0.07);
    padding: 36px 40px;
    display: flex; align-items: center; justify-content: space-between; gap: 32px;
    flex-wrap: wrap; margin-bottom: 40px; position: relative; overflow: hidden;
  }
  .adm-cta-upload::before {
    content: ''; position: absolute; right: -60px; top: -60px;
    width: 200px; height: 200px; border-radius: 50%;
    background: radial-gradient(circle, rgba(123,16,224,0.12) 0%, transparent 70%);
    pointer-events: none;
  }
  .adm-cta-upload-left {}
  .adm-cta-upload-label {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.62rem; font-weight: 700;
    letter-spacing: 0.2em; text-transform: uppercase; color: #7b10e0; margin-bottom: 8px;
  }
  .adm-cta-upload-title {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
    font-size: clamp(1.6rem, 3vw, 2.4rem); text-transform: uppercase; line-height: 1;
    margin-bottom: 10px;
  }
  .adm-cta-upload-sub { font-size: 0.82rem; color: #555; font-weight: 300; line-height: 1.6; }

  /* ---- SECTION TITLE ---- */
  .adm-section-title {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
    font-size: 1.4rem; text-transform: uppercase; margin-bottom: 16px;
    display: flex; align-items: center; justify-content: space-between; gap: 16px;
  }
  .adm-section-title span { font-size: 0.7rem; font-weight: 400; color: #555; font-family: 'Barlow'; text-transform: none; }

  /* ---- PROJECTS LIST ---- */
  .adm-projects { display: flex; flex-direction: column; gap: 2px; margin-bottom: 40px; }
  .adm-project-row {
    background: #111; padding: 18px 24px;
    display: flex; align-items: center; gap: 16px; flex-wrap: wrap;
    border-left: 2px solid transparent;
    transition: background 0.2s, border-color 0.2s;
  }
  .adm-project-row:hover { background: #161616; border-left-color: #7b10e0; }
  .adm-project-thumb {
    width: 56px; height: 40px; object-fit: cover; flex-shrink: 0;
    border: 1px solid rgba(255,255,255,0.06);
  }
  .adm-project-thumb-placeholder {
    width: 56px; height: 40px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900; font-size: 1rem;
    color: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.06);
  }
  .adm-project-info { flex: 1; min-width: 0; }
  .adm-project-name {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
    font-size: 1rem; text-transform: uppercase; white-space: nowrap;
    overflow: hidden; text-overflow: ellipsis;
  }
  .adm-project-meta { font-size: 0.72rem; color: #555; margin-top: 2px; }
  .adm-project-cat {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.62rem; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    background: rgba(123,16,224,0.12); border: 1px solid rgba(123,16,224,0.2);
    color: #7b10e0; padding: 3px 8px; white-space: nowrap;
  }
  .adm-project-actions { display: flex; gap: 8px; flex-shrink: 0; }

  /* ---- BOUTONS ---- */
  .adm-btn {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.72rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase; padding: 9px 18px;
    cursor: pointer; transition: all 0.2s; border: none;
    display: inline-flex; align-items: center; gap: 6px; text-decoration: none;
    white-space: nowrap;
  }
  .adm-btn-primary { background: #7b10e0; color: #fff; }
  .adm-btn-primary:hover { background: #6209b8; transform: translateY(-1px); }
  .adm-btn-ghost { background: transparent; border: 1px solid rgba(255,255,255,0.1); color: #f0f0f0; }
  .adm-btn-ghost:hover { border-color: #7b10e0; color: #7b10e0; }
  .adm-btn-danger { background: transparent; border: 1px solid rgba(255,68,68,0.2); color: #ff6666; }
  .adm-btn-danger:hover { background: rgba(255,68,68,0.1); border-color: #ff4444; }
  .adm-btn-sm { padding: 6px 12px; font-size: 0.65rem; }

  /* ---- FORM SECTIONS ---- */
  .adm-form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; margin-bottom: 16px; }
  .adm-field { margin-bottom: 16px; }
  .adm-field-label {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.58rem; font-weight: 700;
    letter-spacing: 0.2em; text-transform: uppercase; color: #555; margin-bottom: 7px; display: block;
  }
  .adm-field input, .adm-field textarea {
    width: 100%; background: #141414; border: 1px solid rgba(255,255,255,0.08);
    color: #f0f0f0; font-family: 'Barlow', sans-serif; font-size: 0.88rem; font-weight: 300;
    padding: 12px 14px; outline: none; transition: border-color 0.2s;
  }
  .adm-field input:focus, .adm-field textarea:focus { border-color: #7b10e0; }
  .adm-field input::placeholder, .adm-field textarea::placeholder { color: #333; }
  .adm-field textarea { resize: vertical; min-height: 80px; }
  .adm-save-row {
    display: flex; align-items: center; gap: 12px; margin-top: 24px;
    padding-top: 24px; border-top: 1px solid rgba(255,255,255,0.07);
  }
  .adm-toast {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.72rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase; color: #00E5FF;
    opacity: 0; transition: opacity 0.3s;
  }
  .adm-toast.show { opacity: 1; }

  /* ---- CARD ---- */
  .adm-card {
    background: #111; border: 1px solid rgba(255,255,255,0.07);
    padding: 32px; margin-bottom: 24px;
  }
  .adm-card-title {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 700; font-size: 1rem;
    text-transform: uppercase; margin-bottom: 6px; display: flex; align-items: center; gap: 10px;
  }
  .adm-card-title::before { content: ''; width: 16px; height: 2px; background: #7b10e0; }
  .adm-card-sub { font-size: 0.78rem; color: #555; font-weight: 300; margin-bottom: 24px; line-height: 1.6; }

  /* ---- CONFIRM OVERLAY ---- */
  .adm-overlay {
    position: fixed; inset: 0; z-index: 200;
    background: rgba(0,0,0,0.85); backdrop-filter: blur(6px);
    display: flex; align-items: center; justify-content: center; padding: 24px;
  }
  .adm-confirm-box {
    background: #111; border: 1px solid rgba(255,255,255,0.1);
    padding: 36px 32px; max-width: 400px; width: 100%;
  }
  .adm-confirm-title {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 900; font-size: 1.4rem;
    text-transform: uppercase; margin-bottom: 10px;
  }
  .adm-confirm-sub { font-size: 0.82rem; color: #555; margin-bottom: 28px; line-height: 1.6; }
  .adm-confirm-actions { display: flex; gap: 10px; }

  /* ---- DEMANDES ---- */
  .adm-req-list { display: flex; flex-direction: column; gap: 2px; }
  .adm-req-row {
    background: #111; border-left: 2px solid transparent;
    transition: background 0.2s, border-color 0.2s;
    cursor: pointer;
  }
  .adm-req-row:hover { background: #161616; }
  .adm-req-row.unread { border-left-color: #7b10e0; }
  .adm-req-row.open { background: #161616; }
  .adm-req-header {
    padding: 18px 24px;
    display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
  }
  .adm-req-dot {
    width: 7px; height: 7px; border-radius: 50%;
    background: #7b10e0; flex-shrink: 0;
    box-shadow: 0 0 6px #7b10e0;
  }
  .adm-req-dot.read { background: transparent; box-shadow: none; border: 1px solid #333; }
  .adm-req-name {
    font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
    font-size: 1rem; text-transform: uppercase; flex: 1; min-width: 0;
  }
  .adm-req-email { font-size: 0.75rem; color: #555; }
  .adm-req-type {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.6rem; font-weight: 700;
    letter-spacing: 0.14em; text-transform: uppercase;
    background: rgba(123,16,224,0.1); border: 1px solid rgba(123,16,224,0.2);
    color: #7b10e0; padding: 3px 8px; white-space: nowrap;
  }
  .adm-req-budget {
    font-family: 'Space Mono', monospace; font-size: 0.68rem; color: #00E5FF;
    white-space: nowrap;
  }
  .adm-req-date { font-size: 0.7rem; color: #444; white-space: nowrap; }
  .adm-req-chevron { color: #444; font-size: 0.7rem; transition: transform 0.25s; flex-shrink: 0; }
  .adm-req-row.open .adm-req-chevron { transform: rotate(180deg); }
  .adm-req-body {
    padding: 0 24px 24px 24px; border-top: 1px solid rgba(255,255,255,0.05);
    display: grid; grid-template-columns: 1fr 1fr; gap: 20px 40px;
    animation: fadeIn 0.2s ease;
  }
  @keyframes fadeIn { from { opacity:0; transform:translateY(-4px); } to { opacity:1; transform:none; } }
  .adm-req-field { padding-top: 16px; }
  .adm-req-field-label {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.55rem; font-weight: 700;
    letter-spacing: 0.2em; text-transform: uppercase; color: #444; margin-bottom: 6px;
  }
  .adm-req-field-val { font-size: 0.85rem; color: #ccc; font-weight: 300; line-height: 1.6; }
  .adm-req-msg { grid-column: span 2; }
  .adm-req-actions {
    grid-column: span 2; display: flex; gap: 10px; padding-top: 8px;
    border-top: 1px solid rgba(255,255,255,0.05);
  }
  .adm-req-empty {
    padding: 48px 24px; text-align: center;
    background: #111; color: #333; font-size: 0.85rem;
  }
  .adm-req-empty span { display: block; font-size: 2rem; margin-bottom: 12px; opacity: 0.15; }
  /* Badge notif sur onglet */
  .adm-tab-badge {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 18px; height: 18px; padding: 0 5px;
    background: #7b10e0; color: #fff; border-radius: 9px;
    font-size: 0.6rem; font-weight: 700; font-family: 'Space Mono', monospace;
    margin-left: 7px; line-height: 1;
  }
  /* Filtres demandes */
  .adm-req-filters {
    display: flex; gap: 8px; margin-bottom: 20px; flex-wrap: wrap;
    align-items: center; justify-content: space-between;
  }
  .adm-req-filter-group { display: flex; gap: 6px; }
  .adm-req-filter {
    font-family: 'Barlow Condensed', sans-serif; font-size: 0.68rem; font-weight: 700;
    letter-spacing: 0.12em; text-transform: uppercase; cursor: pointer;
    background: transparent; border: 1px solid rgba(255,255,255,0.08);
    color: #555; padding: 7px 14px; transition: all 0.2s;
  }
  .adm-req-filter:hover { color: #f0f0f0; border-color: rgba(255,255,255,0.2); }
  .adm-req-filter.active { background: #7b10e0; border-color: #7b10e0; color: #fff; }

  /* ---- RESPONSIVE ---- */
  @media (max-width: 768px) {
    .adm-nav, .adm-tabs, .adm-content { padding-left: 16px; padding-right: 16px; }
    .adm-stats { grid-template-columns: repeat(2, 1fr); }
    .adm-form-grid { grid-template-columns: 1fr; }
    .adm-cta-upload { flex-direction: column; align-items: flex-start; }
    .adm-project-row { flex-wrap: wrap; }
    .adm-project-actions { width: 100%; }
    .adm-req-body { grid-template-columns: 1fr; }
    .adm-req-msg, .adm-req-actions { grid-column: span 1; }
    .adm-req-filters { flex-direction: column; align-items: flex-start; }
  }
  @media (max-width: 480px) {
    .adm-login-box { padding: 32px 20px; }
    .adm-stats { grid-template-columns: 1fr 1fr; }
  }
`;

const API = 'https://portfolio.cookieheadfox.workers.dev';

/* ============================================================
   SOUS-COMPOSANTS
============================================================ */

/* -- Login -- */
function Login({ onSuccess }) {
  const [pw, setPw]       = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const attempt = async () => {
    if (!pw || loading) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: pw }),
      });
      if (res.ok) {
        const { token } = await res.json();
        sessionStorage.setItem('adm_token', token);
        onSuccess(token);
      } else {
        setError(true);
        setPw('');
        setTimeout(() => setError(false), 3000);
      }
    } catch {
      setError(true);
      setPw('');
      setTimeout(() => setError(false), 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adm-login">
      <div className="adm-login-box">
        <span className="adm-login-logo">HEYIM<span>PURP</span></span>
        <div className="adm-login-title">ACCÈS<br />ADMIN</div>
        <div className="adm-login-sub">Zone restreinte — identifiez-vous.</div>
        <label className="adm-login-label">Mot de passe</label>
        <input
          type="password"
          className={`adm-login-input${error ? ' err' : ''}`}
          placeholder="••••••••••••"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && attempt()}
          autoFocus
        />
        {error && <div className="adm-login-err">✗ Mot de passe incorrect</div>}
        <button className="adm-login-btn" onClick={attempt} disabled={loading}>
          {loading ? 'Connexion…' : 'Connexion →'}
        </button>
      </div>
    </div>
  );
}

/* -- Confirm dialog -- */
function Confirm({ title, sub, onConfirm, onCancel }) {
  return (
    <div className="adm-overlay">
      <div className="adm-confirm-box">
        <div className="adm-confirm-title">{title}</div>
        <div className="adm-confirm-sub">{sub}</div>
        <div className="adm-confirm-actions">
          <button className="adm-btn adm-btn-danger" onClick={onConfirm}>Confirmer</button>
          <button className="adm-btn adm-btn-ghost" onClick={onCancel}>Annuler</button>
        </div>
      </div>
    </div>
  );
}

/* ============================================================
   TAB : OVERVIEW
============================================================ */
function TabOverview({ projects, onEditProject, unreadCount, onGoToRequests }) {
  const navigate = useNavigate();
  const nbImgs = projects.filter(p => p.heroImage).length;
  const cats = [...new Set(projects.map(p => p.cat))].length;
  const recent = [...projects].reverse().slice(0, 5);

  return (
    <>
      {/* Notif demandes non lues */}
      {unreadCount > 0 && (
        <div
          onClick={onGoToRequests}
          style={{
            background: 'rgba(123,16,224,0.1)', border: '1px solid rgba(123,16,224,0.3)',
            padding: '14px 20px', marginBottom: 24, cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16,
            transition: 'background 0.2s',
          }}
          onMouseOver={e => e.currentTarget.style.background = 'rgba(123,16,224,0.18)'}
          onMouseOut={e => e.currentTarget.style.background = 'rgba(123,16,224,0.1)'}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 8, height: 8, borderRadius: '50%', background: '#7b10e0',
              boxShadow: '0 0 8px #7b10e0', flexShrink: 0,
              animation: 'blink 2s ease-in-out infinite',
            }} />
            <span style={{ fontFamily: "'Barlow Condensed'", fontSize: '0.82rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#f0f0f0' }}>
              {unreadCount} nouvelle{unreadCount > 1 ? 's' : ''} demande{unreadCount > 1 ? 's' : ''} de contact non lue{unreadCount > 1 ? 's' : ''}
            </span>
          </div>
          <span style={{ fontFamily: "'Barlow Condensed'", fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#7b10e0' }}>
            Voir → 
          </span>
        </div>
      )}
      {/* Stats */}
      <div className="adm-stats">
        <div className="adm-stat">
          <div className="adm-stat-num">{projects.length}</div>
          <div className="adm-stat-label">Projets total</div>
        </div>
        <div className="adm-stat">
          <div className="adm-stat-num">{nbImgs}</div>
          <div className="adm-stat-label">Avec image</div>
        </div>
        <div className="adm-stat">
          <div className="adm-stat-num">{cats}</div>
          <div className="adm-stat-label">Catégories</div>
        </div>
        <div className="adm-stat">
          <div className="adm-stat-num">{projects.reduce((a, p) => a + (p.images || []).filter(Boolean).length, 0)}</div>
          <div className="adm-stat-label">Visuels galerie</div>
        </div>
      </div>

      {/* CTA Upload */}
      <div className="adm-cta-upload">
        <div className="adm-cta-upload-left">
          <div className="adm-cta-upload-label">Action rapide</div>
          <div className="adm-cta-upload-title">AJOUTER UN<br />NOUVEAU PROJET</div>
          <div className="adm-cta-upload-sub">
            Uploadez vos images, remplissez les infos et publiez directement dans votre portfolio.
          </div>
        </div>
        <Link to="/admin/upload" className="adm-btn adm-btn-primary" style={{ fontSize: '0.88rem', padding: '14px 32px' }}>
          ⊕ Upload un projet
        </Link>
      </div>

      {/* Derniers projets */}
      <div className="adm-section-title">
        Derniers projets ajoutés
        <span>{projects.length} projets au total</span>
      </div>
      <div className="adm-projects">
        {recent.length === 0 && (
          <div style={{ padding: '32px 24px', color: '#444', fontSize: '0.85rem', background: '#111' }}>
            Aucun projet pour l'instant. Commencez par en uploader un.
          </div>
        )}
        {recent.map(p => (
          <div className="adm-project-row" key={p.id}>
            {p.heroImage
              ? <img className="adm-project-thumb" src={p.heroImage} alt={p.name} />
              : <div className="adm-project-thumb-placeholder">{p.letter || p.name?.[0] || '?'}</div>
            }
            <div className="adm-project-info">
              <div className="adm-project-name">{p.name || '(sans titre)'}</div>
              <div className="adm-project-meta">{p.client} {p.date ? `· ${p.date}` : ''}</div>
            </div>
            <div className="adm-project-cat">{p.catLabel}</div>
            <div className="adm-project-actions">
              <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={() => onEditProject(p.id)}>Éditer</button>
              <Link to={`/projet/${p.id}`} target="_blank" className="adm-btn adm-btn-ghost adm-btn-sm">Voir ↗</Link>
            </div>
          </div>
        ))}
      </div>

      {projects.length > 5 && (
        <div style={{ textAlign: 'center' }}>
          <button className="adm-btn adm-btn-ghost" style={{ width: '100%', marginTop: 2 }}
            onClick={() => {}}>
            Voir tous les projets → (onglet Projets)
          </button>
        </div>
      )}
    </>
  );
}

/* ============================================================
   TAB : PROJETS
============================================================ */
function TabProjets({ projects, onReload }) {
  const navigate = useNavigate();
  const [confirm, setConfirm] = useState(null);

  const handleDelete = (id) => {
    const all = getProjects().filter(p => p.id !== id);
    localStorage.setItem('projects', JSON.stringify(all));
    onReload();
    setConfirm(null);
  };

  return (
    <>
      <div className="adm-section-title" style={{ marginBottom: 20 }}>
        Tous les projets
        <Link to="/admin/upload" className="adm-btn adm-btn-primary adm-btn-sm">⊕ Nouveau projet</Link>
      </div>

      <div className="adm-projects">
        {projects.length === 0 && (
          <div style={{ padding: '32px 24px', color: '#444', fontSize: '0.85rem', background: '#111' }}>
            Aucun projet. <Link to="/admin/upload" style={{ color: '#7b10e0', textDecoration: 'none' }}>En créer un →</Link>
          </div>
        )}
        {projects.map((p, i) => (
          <div className="adm-project-row" key={p.id}>
            <div style={{ font: '700 0.65rem/1 Barlow Condensed,sans-serif', color: '#7b10e0', minWidth: 28 }}>
              {String(i + 1).padStart(2, '0')}
            </div>
            {p.heroImage
              ? <img className="adm-project-thumb" src={p.heroImage} alt={p.name} />
              : <div className="adm-project-thumb-placeholder">{p.letter || p.name?.[0] || '?'}</div>
            }
            <div className="adm-project-info">
              <div className="adm-project-name">{p.name || '(sans titre)'}</div>
              <div className="adm-project-meta">
                {p.client}{p.date ? ` · ${p.date}` : ''} ·
                {' '}{(p.images || []).filter(Boolean).length} visuel(s) galerie
              </div>
            </div>
            <div className="adm-project-cat">{p.catLabel}</div>
            <div className="adm-project-actions">
              <Link
                to={`/admin/upload?id=${p.id}`}
                className="adm-btn adm-btn-ghost adm-btn-sm"
              >
                Éditer
              </Link>
              <Link to={`/projet/${p.id}`} target="_blank" className="adm-btn adm-btn-ghost adm-btn-sm">
                Voir ↗
              </Link>
              <button
                className="adm-btn adm-btn-danger adm-btn-sm"
                onClick={() => setConfirm(p)}
              >
                ✕
              </button>
            </div>
          </div>
        ))}
      </div>

      {confirm && (
        <Confirm
          title="Supprimer ce projet ?"
          sub={`"${confirm.name}" sera définitivement supprimé de votre portfolio.`}
          onConfirm={() => handleDelete(confirm.id)}
          onCancel={() => setConfirm(null)}
        />
      )}
    </>
  );
}

/* ============================================================
   TAB : ACCUEIL (édition textes page d'accueil)
============================================================ */
function TabAccueil() {
  const [hero, setHero] = useState({
    badge: 'Disponible pour de nouveaux projets',
    title: 'DESIGN QUI',
    subtitle: 'FAIT IMPACT',
    desc: "Graphiste <span>indépendant</span> basé en France. Je crée des identités visuelles, des interfaces et des univers graphiques qui marquent les esprits.",
  });
  const [stats, setStats] = useState({
    s1: '50+', s1l: 'Projets réalisés',
    s2: '35+', s2l: 'Clients satisfaits',
    s3: '5+',  s3l: "Années d'expérience",
    s4: '∞',
  });
  const [toast, setToast] = useState(false);

  useEffect(() => {
    const h = JSON.parse(localStorage.getItem('hero_content') || 'null');
    if (h) setHero(v => ({ ...v, ...h }));
    const s = JSON.parse(localStorage.getItem('stats_content') || 'null');
    if (s) setStats(v => ({ ...v, ...s }));
  }, []);

  const saveHero = () => {
    localStorage.setItem('hero_content', JSON.stringify(hero));
    localStorage.setItem('stats_content', JSON.stringify(stats));
    setToast(true); setTimeout(() => setToast(false), 2500);
  };

  const sh = (field) => (e) => setHero(v => ({ ...v, [field]: e.target.value }));
  const ss = (field) => (e) => setStats(v => ({ ...v, [field]: e.target.value }));

  return (
    <>
      <div className="adm-card">
        <div className="adm-card-title">Textes Hero</div>
        <div className="adm-card-sub">Ces textes s'affichent en haut de la page d'accueil.</div>
        <div className="adm-form-grid">
          <div className="adm-field">
            <label className="adm-field-label">Badge (disponibilité)</label>
            <input type="text" value={hero.badge} onChange={sh('badge')} />
          </div>
          <div className="adm-field">
            <label className="adm-field-label">Titre ligne 1 (blanc)</label>
            <input type="text" value={hero.title} onChange={sh('title')} />
          </div>
          <div className="adm-field">
            <label className="adm-field-label">Titre ligne 2 (gradient)</label>
            <input type="text" value={hero.subtitle} onChange={sh('subtitle')} />
          </div>
        </div>
        <div className="adm-field">
          <label className="adm-field-label">Description (HTML autorisé pour &lt;span&gt;)</label>
          <textarea value={hero.desc} onChange={sh('desc')} rows={3} />
        </div>
      </div>

      <div className="adm-card">
        <div className="adm-card-title">Statistiques</div>
        <div className="adm-card-sub">Les 4 chiffres affichés sous le hero.</div>
        <div className="adm-form-grid">
          <div className="adm-field"><label className="adm-field-label">Stat 1 — Valeur</label><input type="text" value={stats.s1} onChange={ss('s1')} /></div>
          <div className="adm-field"><label className="adm-field-label">Stat 1 — Label</label><input type="text" value={stats.s1l} onChange={ss('s1l')} /></div>
          <div className="adm-field"><label className="adm-field-label">Stat 2 — Valeur</label><input type="text" value={stats.s2} onChange={ss('s2')} /></div>
          <div className="adm-field"><label className="adm-field-label">Stat 2 — Label</label><input type="text" value={stats.s2l} onChange={ss('s2l')} /></div>
          <div className="adm-field"><label className="adm-field-label">Stat 3 — Valeur</label><input type="text" value={stats.s3} onChange={ss('s3')} /></div>
          <div className="adm-field"><label className="adm-field-label">Stat 3 — Label</label><input type="text" value={stats.s3l} onChange={ss('s3l')} /></div>
          <div className="adm-field"><label className="adm-field-label">Stat 4 — Valeur</label><input type="text" value={stats.s4} onChange={ss('s4')} /></div>
        </div>
      </div>

      <div className="adm-save-row">
        <button className="adm-btn adm-btn-primary" onClick={saveHero}>Sauvegarder les textes</button>
        <span className={`adm-toast ${toast ? 'show' : ''}`}>✓ Sauvegardé !</span>
      </div>
    </>
  );
}

/* ============================================================
   TAB : CONTACT
============================================================ */
function TabContact() {
  const [info, setInfo] = useState({
    email: 'hello@heyimpurp.fr',
    phone: 'A Venir',
    location: 'France — Remote worldwide',
    avail: 'Disponible pour de nouveaux projets',
    desc: "Vous avez une idée, un projet, une deadline serrée ? Je réponds à tous les messages sous 24h.",
  });
  const [toast, setToast] = useState(false);

  useEffect(() => {
    const ci = JSON.parse(localStorage.getItem('contact_info') || 'null');
    if (ci) setInfo(v => ({ ...v, ...ci }));
  }, []);

  const save = () => {
    localStorage.setItem('contact_info', JSON.stringify(info));
    setToast(true); setTimeout(() => setToast(false), 2500);
  };

  const s = (field) => (e) => setInfo(v => ({ ...v, [field]: e.target.value }));

  return (
    <div className="adm-card">
      <div className="adm-card-title">Informations de contact</div>
      <div className="adm-card-sub">Ces infos s'affichent sur la page Contact de votre site.</div>
      <div className="adm-form-grid">
        <div className="adm-field"><label className="adm-field-label">E-mail public</label><input type="email" value={info.email} onChange={s('email')} /></div>
        <div className="adm-field"><label className="adm-field-label">Téléphone</label><input type="text" value={info.phone} onChange={s('phone')} /></div>
        <div className="adm-field"><label className="adm-field-label">Localisation</label><input type="text" value={info.location} onChange={s('location')} /></div>
        <div className="adm-field"><label className="adm-field-label">Message disponibilité</label><input type="text" value={info.avail} onChange={s('avail')} /></div>
      </div>
      <div className="adm-field">
        <label className="adm-field-label">Texte intro (page contact)</label>
        <textarea value={info.desc} onChange={s('desc')} rows={3} />
      </div>
      <div className="adm-save-row">
        <button className="adm-btn adm-btn-primary" onClick={save}>Sauvegarder</button>
        <span className={`adm-toast ${toast ? 'show' : ''}`}>✓ Sauvegardé !</span>
      </div>
    </div>
  );
}

/* ============================================================
   TAB : SÉCURITÉ
============================================================ */
function TabSecurity({ onLogout }) {
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [err, setErr] = useState('');
  const [toast, setToast] = useState(false);

  const save = async () => {
    setErr('');
    if (pw.length < 8) { setErr('Minimum 8 caractères.'); return; }
    if (pw !== pw2)    { setErr('Les mots de passe ne correspondent pas.'); return; }
    const h = await sha256(pw);
    localStorage.setItem('adm_pw_hash', h);
    setPw(''); setPw2('');
    setToast(true); setTimeout(() => setToast(false), 2500);
  };

  return (
    <div className="adm-card">
      <div className="adm-card-title">Changer le mot de passe</div>
      <div className="adm-card-sub">
        Le mot de passe est stocké sous forme de hash SHA-256 dans votre localStorage — jamais en clair dans le code.
      </div>
      <div className="adm-form-grid">
        <div className="adm-field">
          <label className="adm-field-label">Nouveau mot de passe</label>
          <input type="password" placeholder="Minimum 8 caractères" value={pw} onChange={(e) => setPw(e.target.value)} />
        </div>
        <div className="adm-field">
          <label className="adm-field-label">Confirmer</label>
          <input type="password" placeholder="Répétez le mot de passe" value={pw2} onChange={(e) => setPw2(e.target.value)} />
        </div>
      </div>
      {err && <div style={{ color: '#ff6666', fontSize: '0.8rem', marginBottom: 12 }}>{err}</div>}
      <div className="adm-save-row">
        <button className="adm-btn adm-btn-primary" onClick={save}>Mettre à jour</button>
        <span className={`adm-toast ${toast ? 'show' : ''}`}>✓ Mot de passe mis à jour !</span>
        <div style={{ flex: 1 }} />
        <button className="adm-btn adm-btn-danger" onClick={onLogout}>Se déconnecter</button>
      </div>
    </div>
  );
}

/* ============================================================
   TAB : DEMANDES DE CONTACT
============================================================ */
const BUDGET_LABELS = {
  '500': '< 500€', '1000': '500€–1k€', '2000': '1k–2k€',
  '5000': '2k–5k€', 'plus': '> 5 000€', '': '—',
};
const TIMELINE_LABELS = {
  'urgent': 'Urgent (< 2 sem.)', 'normal': 'Normal (1 mois)',
  'flexible': 'Flexible', 'nsp': 'Non définie', '': '—',
};
const TYPE_LABELS = {
  'identite': 'Identité Visuelle', 'ui': 'UI / UX', 'motion': 'Motion Design',
  'print': 'Print & Édition', 'illustration': 'Illustration', 'autre': 'Autre', '': '—',
};

function formatDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })
    + ' à ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
}

function RequestRow({ req, onMarkRead, onDelete }) {
  const [open, setOpen] = useState(false);

  const toggle = () => {
    setOpen(o => !o);
    if (!req.read) onMarkRead(req.id);
  };

  return (
    <div className={`adm-req-row${req.read ? '' : ' unread'}${open ? ' open' : ''}`}>
      <div className="adm-req-header" onClick={toggle}>
        <div className={`adm-req-dot${req.read ? ' read' : ''}`} />
        <div className="adm-req-name">{req.firstname} {req.lastname}</div>
        <div className="adm-req-email">{req.email}</div>
        {req.projectType && <div className="adm-req-type">{TYPE_LABELS[req.projectType] || req.projectType}</div>}
        {req.budget && <div className="adm-req-budget">{BUDGET_LABELS[req.budget] || req.budget}</div>}
        <div className="adm-req-date">{formatDate(req.receivedAt)}</div>
        <div className="adm-req-chevron">▼</div>
      </div>

      {open && (
        <div className="adm-req-body">
          <div className="adm-req-field">
            <div className="adm-req-field-label">Entreprise</div>
            <div className="adm-req-field-val">{req.company || '—'}</div>
          </div>
          <div className="adm-req-field">
            <div className="adm-req-field-label">Type de projet</div>
            <div className="adm-req-field-val">{TYPE_LABELS[req.projectType] || '—'}</div>
          </div>
          <div className="adm-req-field">
            <div className="adm-req-field-label">Budget estimé</div>
            <div className="adm-req-field-val">{BUDGET_LABELS[req.budget] || '—'}</div>
          </div>
          <div className="adm-req-field">
            <div className="adm-req-field-label">Timeline</div>
            <div className="adm-req-field-val">{TIMELINE_LABELS[req.timeline] || '—'}</div>
          </div>
          <div className="adm-req-field">
            <div className="adm-req-field-label">Source</div>
            <div className="adm-req-field-val">{req.source || '—'}</div>
          </div>
          <div className="adm-req-field">
            <div className="adm-req-field-label">Reçu le</div>
            <div className="adm-req-field-val">{formatDate(req.receivedAt)}</div>
          </div>
          <div className="adm-req-field adm-req-msg">
            <div className="adm-req-field-label">Message</div>
            <div className="adm-req-field-val" style={{ whiteSpace: 'pre-wrap' }}>{req.message}</div>
          </div>
          <div className="adm-req-actions">
            <a
              href={`mailto:${req.email}?subject=Re: votre demande de projet`}
              className="adm-btn adm-btn-primary adm-btn-sm"
            >
              ✉ Répondre par mail
            </a>
            {!req.read && (
              <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={() => onMarkRead(req.id)}>
                Marquer lu
              </button>
            )}
            <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => onDelete(req.id)}>
              ✕ Supprimer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function TabDemandes() {
  const [requests, setRequests] = useState([]);
  const [filter, setFilter] = useState('all');

  const load = () => {
    setRequests(JSON.parse(localStorage.getItem('contact_requests') || '[]'));
  };

  useEffect(() => { load(); }, []);

  const markRead = (id) => {
    const updated = requests.map(r => r.id === id ? { ...r, read: true } : r);
    localStorage.setItem('contact_requests', JSON.stringify(updated));
    setRequests(updated);
  };

  const markAllRead = () => {
    const updated = requests.map(r => ({ ...r, read: true }));
    localStorage.setItem('contact_requests', JSON.stringify(updated));
    setRequests(updated);
  };

  const deleteReq = (id) => {
    const updated = requests.filter(r => r.id !== id);
    localStorage.setItem('contact_requests', JSON.stringify(updated));
    setRequests(updated);
  };

  const unread = requests.filter(r => !r.read).length;
  const filtered = filter === 'unread' ? requests.filter(r => !r.read)
    : filter === 'read' ? requests.filter(r => r.read)
    : requests;

  return (
    <>
      <div className="adm-req-filters">
        <div className="adm-req-filter-group">
          <button className={`adm-req-filter${filter === 'all' ? ' active' : ''}`} onClick={() => setFilter('all')}>
            Tous ({requests.length})
          </button>
          <button className={`adm-req-filter${filter === 'unread' ? ' active' : ''}`} onClick={() => setFilter('unread')}>
            Non lus ({unread})
          </button>
          <button className={`adm-req-filter${filter === 'read' ? ' active' : ''}`} onClick={() => setFilter('read')}>
            Lus ({requests.length - unread})
          </button>
        </div>
        {unread > 0 && (
          <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={markAllRead}>
            Tout marquer comme lu
          </button>
        )}
      </div>

      <div className="adm-req-list">
        {filtered.length === 0 ? (
          <div className="adm-req-empty">
            <span>✉</span>
            {filter === 'all'
              ? 'Aucune demande reçue pour l\'instant.'
              : 'Aucune demande dans cette catégorie.'}
          </div>
        ) : (
          filtered.map(req => (
            <RequestRow
              key={req.id}
              req={req}
              onMarkRead={markRead}
              onDelete={deleteReq}
            />
          ))
        )}
      </div>
    </>
  );
}

/* ============================================================
   PAGE PRINCIPALE
============================================================ */
const TABS = [
  { key: 'overview',  label: 'Vue d\'ensemble' },
  { key: 'projets',   label: 'Projets' },
  { key: 'demandes',  label: 'Demandes' },
  { key: 'accueil',   label: 'Page d\'accueil' },
  { key: 'contact',   label: 'Contact' },
  { key: 'security',  label: 'Sécurité' },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [auth, setAuth] = useState(false);
  const [tab, setTab]   = useState('overview');
  const [projects, setProjects] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const reloadUnread = useCallback(() => {
    const reqs = JSON.parse(localStorage.getItem('contact_requests') || '[]');
    setUnreadCount(reqs.filter(r => !r.read).length);
  }, []);

  /* Inject styles */
  useEffect(() => {
    const tag = document.createElement('style');
    tag.id = 'adm-styles';
    tag.textContent = STYLES;
    document.head.appendChild(tag);
    document.title = 'Admin — HEYIMPURP';
    if (sessionStorage.getItem('adm_token')) setAuth(true);
    return () => { document.getElementById('adm-styles')?.remove(); };
  }, []);

  const reloadProjects = useCallback(() => {
    setProjects(getProjects());
  }, []);

  useEffect(() => {
    if (auth) { reloadProjects(); reloadUnread(); }
  }, [auth, reloadProjects, reloadUnread]);

  const handleLogin = () => {
    setAuth(true);
  };

  const handleLogout = () => {
    sessionStorage.removeItem('adm_token');
    setAuth(false);
  };

  const handleEditProject = (id) => {
    navigate(`/admin/upload?id=${id}`);
  };

  if (!auth) return <Login onSuccess={handleLogin} />;

  return (
    <div className="adm">
      {/* NAV */}
      <div className="adm-nav">
        <div className="adm-nav-left">
          <span className="adm-nav-logo">HEYIM<span>PURP</span></span>
          <span className="adm-nav-badge">ADMIN</span>
        </div>
        <div className="adm-nav-right">
          <Link to="/" target="_blank" className="adm-nav-site">Voir le site ↗</Link>
          <button className="adm-nav-logout" onClick={handleLogout}>Déconnexion</button>
        </div>
      </div>

      {/* TABS */}
      <div className="adm-tabs">
        {TABS.map(t => (
          <button
            key={t.key}
            className={`adm-tab ${tab === t.key ? 'active' : ''}`}
            onClick={() => {
              setTab(t.key);
              if (t.key === 'projets') reloadProjects();
              if (t.key === 'demandes') reloadUnread();
            }}
          >
            {t.label}
            {t.key === 'demandes' && unreadCount > 0 && (
              <span className="adm-tab-badge">{unreadCount}</span>
            )}
          </button>
        ))}
      </div>

      {/* CONTENT */}
      <div className="adm-content">
        {tab === 'overview'  && <TabOverview projects={projects} onEditProject={handleEditProject} unreadCount={unreadCount} onGoToRequests={() => setTab('demandes')} />}
        {tab === 'projets'   && <TabProjets  projects={projects} onReload={reloadProjects} />}
        {tab === 'demandes'  && <TabDemandes />}
        {tab === 'accueil'   && <TabAccueil />}
        {tab === 'contact'   && <TabContact />}
        {tab === 'security'  && <TabSecurity onLogout={handleLogout} />}
      </div>
    </div>
  );
}
